import { ReactElement } from 'react';
import { CSS } from '@stitches/react';

import { Sizes } from '@common/types';

export interface DropdownItem {
  id: string;
  label: string;
  optionType?: string;
  disabled?: boolean;
  selected?: boolean;
}

export interface DropdownProps {
  css?: CSS;
  disabled?: boolean;
  buttonStyles?: CSS;
  icon?: ReactElement;
  id: string;
  items: DropdownItem[];
  onSelect?: (item: DropdownItem, key: number) => void;
  selectable?: boolean;
  size?: Sizes;
  tableVariant?: boolean;
  title?: string;
  variant?: DropdownVariant;
}

export interface DropdownListItemProps {
  isSelected?: boolean;
  item: DropdownItem;
  onClick: () => void;
  selectableMode?: boolean;
  selected?: boolean;
}

export enum DropdownVariant {
  DEFAULT = 'DEFAULT',
  PILL = 'PILL',
  TABLE = 'TABLE',
}
